const getFileFromUrl = async (url, name) => {
  const response = await fetch(url)
  const data = await response.blob()
  return new File([data], name, {
    type: data.type
  })
}

export default getFileFromUrl
